import "./main.css";
import $c1fdee2284f63122$exports from "./ar-AE.mjs";
import $81326fc5b8464f3e$exports from "./bg-BG.mjs";
import $61bec992b8f61b70$exports from "./cs-CZ.mjs";
import $92192aa23ec84b2d$exports from "./da-DK.mjs";
import $4db8629ea44949b0$exports from "./de-DE.mjs";
import $d1795c2b69d00f6c$exports from "./el-GR.mjs";
import $16d2015735d51a41$exports from "./en-US.mjs";
import $96cd1e101026681b$exports from "./es-ES.mjs";
import $1133d3628ea10323$exports from "./et-EE.mjs";
import $53163229660d53e4$exports from "./fi-FI.mjs";
import $d0808f7b535fb9b6$exports from "./fr-FR.mjs";
import $658f594fbca84b9b$exports from "./he-IL.mjs";
import $0b62e8a6414bc20c$exports from "./hr-HR.mjs";
import $132d1b97de231314$exports from "./hu-HU.mjs";
import $5653a55498966c6c$exports from "./it-IT.mjs";
import $243f99057b9b0af0$exports from "./ja-JP.mjs";
import $9dbe802a4c1b47ed$exports from "./ko-KR.mjs";
import $ed6bec4d46a5be1b$exports from "./lt-LT.mjs";
import $e203254b4140c831$exports from "./lv-LV.mjs";
import $87004dc1feacb708$exports from "./nb-NO.mjs";
import $fd392c0c0b12ff84$exports from "./nl-NL.mjs";
import $02f96c467435edbf$exports from "./pl-PL.mjs";
import $a516ff2265dc1cde$exports from "./pt-BR.mjs";
import $2a8fe7dc6b71b8d6$exports from "./pt-PT.mjs";
import $459c636d0d282e8f$exports from "./ro-RO.mjs";
import $d49b96bc4e237385$exports from "./ru-RU.mjs";
import $14f44f430d85943b$exports from "./sk-SK.mjs";
import $ced45866328d3850$exports from "./sl-SI.mjs";
import $46417484d64689f8$exports from "./sr-SP.mjs";
import $9d8ccb39096f4575$exports from "./sv-SE.mjs";
import $8e9c1a10ed1cc18a$exports from "./tr-TR.mjs";
import $84c3bf1d3eaf1f59$exports from "./uk-UA.mjs";
import $0212afd59952ac06$exports from "./zh-CN.mjs";
import $87077630a4e30349$exports from "./zh-TW.mjs";
import {createCalendar as $40VnT$createCalendar, endOfMonth as $40VnT$endOfMonth, getWeeksInMonth as $40VnT$getWeeksInMonth, isSameMonth as $40VnT$isSameMonth, isSameDay as $40VnT$isSameDay, getDayOfWeek as $40VnT$getDayOfWeek, isToday as $40VnT$isToday} from "@internationalized/date";
import {createDOMRef as $40VnT$createDOMRef, useStyleProps as $40VnT$useStyleProps, classNames as $40VnT$classNames} from "@react-spectrum/utils";
import $40VnT$react, {useMemo as $40VnT$useMemo, useRef as $40VnT$useRef, useImperativeHandle as $40VnT$useImperativeHandle} from "react";
import {useCalendar as $40VnT$useCalendar, useCalendarGrid as $40VnT$useCalendarGrid, useCalendarCell as $40VnT$useCalendarCell, useRangeCalendar as $40VnT$useRangeCalendar} from "@react-aria/calendar";
import {useCalendarState as $40VnT$useCalendarState, useRangeCalendarState as $40VnT$useRangeCalendarState} from "@react-stately/calendar";
import {useLocale as $40VnT$useLocale, useLocalizedStringFormatter as $40VnT$useLocalizedStringFormatter, useDateFormatter as $40VnT$useDateFormatter} from "@react-aria/i18n";
import {useProviderProps as $40VnT$useProviderProps} from "@react-spectrum/provider";
import {ActionButton as $40VnT$ActionButton} from "@react-spectrum/button";
import $40VnT$spectrumiconsuiChevronLeftLarge from "@spectrum-icons/ui/ChevronLeftLarge";
import $40VnT$spectrumiconsuiChevronRightLarge from "@spectrum-icons/ui/ChevronRightLarge";
import {HelpText as $40VnT$HelpText} from "@react-spectrum/label";
import {VisuallyHidden as $40VnT$VisuallyHidden} from "@react-aria/visually-hidden";
import {mergeProps as $40VnT$mergeProps} from "@react-aria/utils";
import {useFocusRing as $40VnT$useFocusRing} from "@react-aria/focus";
import {useHover as $40VnT$useHover} from "@react-aria/interactions";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




var $52c51313300b3b3e$exports = {};

$parcel$export($52c51313300b3b3e$exports, "focus-ring", () => $52c51313300b3b3e$export$f39a09f249340e2a, (v) => $52c51313300b3b3e$export$f39a09f249340e2a = v);
$parcel$export($52c51313300b3b3e$exports, "i18nFontFamily", () => $52c51313300b3b3e$export$8c4ee2c50c22c514, (v) => $52c51313300b3b3e$export$8c4ee2c50c22c514 = v);
$parcel$export($52c51313300b3b3e$exports, "is-disabled", () => $52c51313300b3b3e$export$d35bc1e505d1ebbf, (v) => $52c51313300b3b3e$export$d35bc1e505d1ebbf = v);
$parcel$export($52c51313300b3b3e$exports, "is-focused", () => $52c51313300b3b3e$export$e7dc768d35940237, (v) => $52c51313300b3b3e$export$e7dc768d35940237 = v);
$parcel$export($52c51313300b3b3e$exports, "is-hovered", () => $52c51313300b3b3e$export$b8813cd5d7824ce7, (v) => $52c51313300b3b3e$export$b8813cd5d7824ce7 = v);
$parcel$export($52c51313300b3b3e$exports, "is-invalid", () => $52c51313300b3b3e$export$14a30de2866685fa, (v) => $52c51313300b3b3e$export$14a30de2866685fa = v);
$parcel$export($52c51313300b3b3e$exports, "is-outsideMonth", () => $52c51313300b3b3e$export$93ff5b06817b3d41, (v) => $52c51313300b3b3e$export$93ff5b06817b3d41 = v);
$parcel$export($52c51313300b3b3e$exports, "is-pressed", () => $52c51313300b3b3e$export$15b73a232798b8d3, (v) => $52c51313300b3b3e$export$15b73a232798b8d3 = v);
$parcel$export($52c51313300b3b3e$exports, "is-range-end", () => $52c51313300b3b3e$export$52890a3cb1ab46b, (v) => $52c51313300b3b3e$export$52890a3cb1ab46b = v);
$parcel$export($52c51313300b3b3e$exports, "is-range-selection", () => $52c51313300b3b3e$export$cd2839d8bb0c6407, (v) => $52c51313300b3b3e$export$cd2839d8bb0c6407 = v);
$parcel$export($52c51313300b3b3e$exports, "is-range-start", () => $52c51313300b3b3e$export$4ce7d3d24e42e411, (v) => $52c51313300b3b3e$export$4ce7d3d24e42e411 = v);
$parcel$export($52c51313300b3b3e$exports, "is-selected", () => $52c51313300b3b3e$export$1e0fb04f31d3c22a, (v) => $52c51313300b3b3e$export$1e0fb04f31d3c22a = v);
$parcel$export($52c51313300b3b3e$exports, "is-selection-end", () => $52c51313300b3b3e$export$50722ae5663230f9, (v) => $52c51313300b3b3e$export$50722ae5663230f9 = v);
$parcel$export($52c51313300b3b3e$exports, "is-selection-start", () => $52c51313300b3b3e$export$f0091c9d6b8c19d3, (v) => $52c51313300b3b3e$export$f0091c9d6b8c19d3 = v);
$parcel$export($52c51313300b3b3e$exports, "is-today", () => $52c51313300b3b3e$export$189f6cc7eaf68d8b, (v) => $52c51313300b3b3e$export$189f6cc7eaf68d8b = v);
$parcel$export($52c51313300b3b3e$exports, "is-unavailable", () => $52c51313300b3b3e$export$38b08f1df825800e, (v) => $52c51313300b3b3e$export$38b08f1df825800e = v);
$parcel$export($52c51313300b3b3e$exports, "next", () => $52c51313300b3b3e$export$48cfd1e771a65c4f, (v) => $52c51313300b3b3e$export$48cfd1e771a65c4f = v);
$parcel$export($52c51313300b3b3e$exports, "prev", () => $52c51313300b3b3e$export$232faf9add678146, (v) => $52c51313300b3b3e$export$232faf9add678146 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar", () => $52c51313300b3b3e$export$2d9837ea36f7a875, (v) => $52c51313300b3b3e$export$2d9837ea36f7a875 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar--padded", () => $52c51313300b3b3e$export$8d90e3a3d21fe428, (v) => $52c51313300b3b3e$export$8d90e3a3d21fe428 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-body", () => $52c51313300b3b3e$export$33407a73687c0e62, (v) => $52c51313300b3b3e$export$33407a73687c0e62 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-date", () => $52c51313300b3b3e$export$c20fe43d14f8fa36, (v) => $52c51313300b3b3e$export$c20fe43d14f8fa36 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-dateText", () => $52c51313300b3b3e$export$cc48a6e73fdb7719, (v) => $52c51313300b3b3e$export$cc48a6e73fdb7719 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-dayOfWeek", () => $52c51313300b3b3e$export$7ff21fe81b21fa51, (v) => $52c51313300b3b3e$export$7ff21fe81b21fa51 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-header", () => $52c51313300b3b3e$export$7efb9b56af6e2d09, (v) => $52c51313300b3b3e$export$7efb9b56af6e2d09 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-monthHeader", () => $52c51313300b3b3e$export$185018e73e57145f, (v) => $52c51313300b3b3e$export$185018e73e57145f = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-months", () => $52c51313300b3b3e$export$5dacd232bfef6687, (v) => $52c51313300b3b3e$export$5dacd232bfef6687 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-nextMonth", () => $52c51313300b3b3e$export$7876229ab722b448, (v) => $52c51313300b3b3e$export$7876229ab722b448 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-prevMonth", () => $52c51313300b3b3e$export$d4c1c2a202a50db2, (v) => $52c51313300b3b3e$export$d4c1c2a202a50db2 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-table", () => $52c51313300b3b3e$export$27f4c38933cceedf, (v) => $52c51313300b3b3e$export$27f4c38933cceedf = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-tableCell", () => $52c51313300b3b3e$export$292b81cfd590634d, (v) => $52c51313300b3b3e$export$292b81cfd590634d = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-Calendar-title", () => $52c51313300b3b3e$export$98ee27555a2b7c01, (v) => $52c51313300b3b3e$export$98ee27555a2b7c01 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-FocusRing-ring", () => $52c51313300b3b3e$export$4109102f950813a6, (v) => $52c51313300b3b3e$export$4109102f950813a6 = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-FocusRing", () => $52c51313300b3b3e$export$24c7f46a6e3605dd, (v) => $52c51313300b3b3e$export$24c7f46a6e3605dd = v);
$parcel$export($52c51313300b3b3e$exports, "spectrum-FocusRing--quiet", () => $52c51313300b3b3e$export$2927016961429360, (v) => $52c51313300b3b3e$export$2927016961429360 = v);
$parcel$export($52c51313300b3b3e$exports, "title", () => $52c51313300b3b3e$export$fb184b623420d9be, (v) => $52c51313300b3b3e$export$fb184b623420d9be = v);
var $52c51313300b3b3e$export$f39a09f249340e2a;
var $52c51313300b3b3e$export$8c4ee2c50c22c514;
var $52c51313300b3b3e$export$d35bc1e505d1ebbf;
var $52c51313300b3b3e$export$e7dc768d35940237;
var $52c51313300b3b3e$export$b8813cd5d7824ce7;
var $52c51313300b3b3e$export$14a30de2866685fa;
var $52c51313300b3b3e$export$93ff5b06817b3d41;
var $52c51313300b3b3e$export$15b73a232798b8d3;
var $52c51313300b3b3e$export$52890a3cb1ab46b;
var $52c51313300b3b3e$export$cd2839d8bb0c6407;
var $52c51313300b3b3e$export$4ce7d3d24e42e411;
var $52c51313300b3b3e$export$1e0fb04f31d3c22a;
var $52c51313300b3b3e$export$50722ae5663230f9;
var $52c51313300b3b3e$export$f0091c9d6b8c19d3;
var $52c51313300b3b3e$export$189f6cc7eaf68d8b;
var $52c51313300b3b3e$export$38b08f1df825800e;
var $52c51313300b3b3e$export$48cfd1e771a65c4f;
var $52c51313300b3b3e$export$232faf9add678146;
var $52c51313300b3b3e$export$2d9837ea36f7a875;
var $52c51313300b3b3e$export$8d90e3a3d21fe428;
var $52c51313300b3b3e$export$33407a73687c0e62;
var $52c51313300b3b3e$export$c20fe43d14f8fa36;
var $52c51313300b3b3e$export$cc48a6e73fdb7719;
var $52c51313300b3b3e$export$7ff21fe81b21fa51;
var $52c51313300b3b3e$export$7efb9b56af6e2d09;
var $52c51313300b3b3e$export$185018e73e57145f;
var $52c51313300b3b3e$export$5dacd232bfef6687;
var $52c51313300b3b3e$export$7876229ab722b448;
var $52c51313300b3b3e$export$d4c1c2a202a50db2;
var $52c51313300b3b3e$export$27f4c38933cceedf;
var $52c51313300b3b3e$export$292b81cfd590634d;
var $52c51313300b3b3e$export$98ee27555a2b7c01;
var $52c51313300b3b3e$export$4109102f950813a6;
var $52c51313300b3b3e$export$24c7f46a6e3605dd;
var $52c51313300b3b3e$export$2927016961429360;
var $52c51313300b3b3e$export$fb184b623420d9be;
$52c51313300b3b3e$export$f39a09f249340e2a = `EuwYBq_focus-ring`;
$52c51313300b3b3e$export$8c4ee2c50c22c514 = `EuwYBq_i18nFontFamily`;
$52c51313300b3b3e$export$d35bc1e505d1ebbf = `EuwYBq_is-disabled`;
$52c51313300b3b3e$export$e7dc768d35940237 = `EuwYBq_is-focused`;
$52c51313300b3b3e$export$b8813cd5d7824ce7 = `EuwYBq_is-hovered`;
$52c51313300b3b3e$export$14a30de2866685fa = `EuwYBq_is-invalid`;
$52c51313300b3b3e$export$93ff5b06817b3d41 = `EuwYBq_is-outsideMonth`;
$52c51313300b3b3e$export$15b73a232798b8d3 = `EuwYBq_is-pressed`;
$52c51313300b3b3e$export$52890a3cb1ab46b = `EuwYBq_is-range-end`;
$52c51313300b3b3e$export$cd2839d8bb0c6407 = `EuwYBq_is-range-selection`;
$52c51313300b3b3e$export$4ce7d3d24e42e411 = `EuwYBq_is-range-start`;
$52c51313300b3b3e$export$1e0fb04f31d3c22a = `EuwYBq_is-selected`;
$52c51313300b3b3e$export$50722ae5663230f9 = `EuwYBq_is-selection-end`;
$52c51313300b3b3e$export$f0091c9d6b8c19d3 = `EuwYBq_is-selection-start`;
$52c51313300b3b3e$export$189f6cc7eaf68d8b = `EuwYBq_is-today`;
$52c51313300b3b3e$export$38b08f1df825800e = `EuwYBq_is-unavailable`;
$52c51313300b3b3e$export$48cfd1e771a65c4f = `EuwYBq_next`;
$52c51313300b3b3e$export$232faf9add678146 = `EuwYBq_prev`;
$52c51313300b3b3e$export$2d9837ea36f7a875 = `EuwYBq_spectrum-Calendar`;
$52c51313300b3b3e$export$8d90e3a3d21fe428 = `EuwYBq_spectrum-Calendar--padded`;
$52c51313300b3b3e$export$33407a73687c0e62 = `EuwYBq_spectrum-Calendar-body`;
$52c51313300b3b3e$export$c20fe43d14f8fa36 = `EuwYBq_spectrum-Calendar-date`;
$52c51313300b3b3e$export$cc48a6e73fdb7719 = `EuwYBq_spectrum-Calendar-dateText`;
$52c51313300b3b3e$export$7ff21fe81b21fa51 = `EuwYBq_spectrum-Calendar-dayOfWeek`;
$52c51313300b3b3e$export$7efb9b56af6e2d09 = `EuwYBq_spectrum-Calendar-header`;
$52c51313300b3b3e$export$185018e73e57145f = `EuwYBq_spectrum-Calendar-monthHeader`;
$52c51313300b3b3e$export$5dacd232bfef6687 = `EuwYBq_spectrum-Calendar-months`;
$52c51313300b3b3e$export$7876229ab722b448 = `EuwYBq_spectrum-Calendar-nextMonth`;
$52c51313300b3b3e$export$d4c1c2a202a50db2 = `EuwYBq_spectrum-Calendar-prevMonth`;
$52c51313300b3b3e$export$27f4c38933cceedf = `EuwYBq_spectrum-Calendar-table`;
$52c51313300b3b3e$export$292b81cfd590634d = `EuwYBq_spectrum-Calendar-tableCell`;
$52c51313300b3b3e$export$98ee27555a2b7c01 = `EuwYBq_spectrum-Calendar-title`;
$52c51313300b3b3e$export$4109102f950813a6 = `EuwYBq_spectrum-FocusRing-ring`;
$52c51313300b3b3e$export$24c7f46a6e3605dd = `EuwYBq_spectrum-FocusRing ${$52c51313300b3b3e$export$4109102f950813a6}`;
$52c51313300b3b3e$export$2927016961429360 = `EuwYBq_spectrum-FocusRing--quiet`;
$52c51313300b3b3e$export$fb184b623420d9be = `EuwYBq_title`;





function $453c556b9066da11$export$5d847498420df57b({ state: state, currentMonth: currentMonth, ...props }) {
    let ref = (0, $40VnT$useRef)();
    let { cellProps: cellProps, buttonProps: buttonProps, isPressed: isPressed, isSelected: isSelected, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, formattedDate: formattedDate } = (0, $40VnT$useCalendarCell)({
        ...props,
        isDisabled: !(0, $40VnT$isSameMonth)(props.date, currentMonth)
    }, state, ref);
    let isUnavailable = state.isCellUnavailable(props.date) && !isDisabled;
    let isLastSelectedBeforeDisabled = !isDisabled && !isInvalid && state.isCellUnavailable(props.date.add({
        days: 1
    }));
    let isFirstSelectedAfterDisabled = !isDisabled && !isInvalid && state.isCellUnavailable(props.date.subtract({
        days: 1
    }));
    let highlightedRange = "highlightedRange" in state && state.highlightedRange;
    let isSelectionStart = isSelected && highlightedRange && (0, $40VnT$isSameDay)(props.date, highlightedRange.start);
    let isSelectionEnd = isSelected && highlightedRange && (0, $40VnT$isSameDay)(props.date, highlightedRange.end);
    let { locale: locale } = (0, $40VnT$useLocale)();
    let dayOfWeek = (0, $40VnT$getDayOfWeek)(props.date, locale);
    let isRangeStart = isSelected && (isFirstSelectedAfterDisabled || dayOfWeek === 0 || props.date.day === 1);
    let isRangeEnd = isSelected && (isLastSelectedBeforeDisabled || dayOfWeek === 6 || props.date.day === currentMonth.calendar.getDaysInMonth(currentMonth));
    let { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $40VnT$useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $40VnT$useHover)({
        isDisabled: isDisabled || isUnavailable || state.isReadOnly
    });
    return /*#__PURE__*/ (0, $40VnT$react).createElement("td", {
        ...cellProps,
        className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-tableCell")
    }, /*#__PURE__*/ (0, $40VnT$react).createElement("span", {
        ...(0, $40VnT$mergeProps)(buttonProps, hoverProps, focusProps),
        ref: ref,
        className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-date", {
            "is-today": (0, $40VnT$isToday)(props.date, state.timeZone),
            "is-selected": isSelected,
            "is-focused": isFocused && isFocusVisible,
            // Style disabled (i.e. out of min/max range), but selected dates as unavailable
            // since it is more clear than trying to dim the selection.
            "is-disabled": isDisabled && !isInvalid,
            "is-unavailable": isUnavailable || isInvalid && isDisabled,
            "is-outsideMonth": !(0, $40VnT$isSameMonth)(props.date, currentMonth),
            "is-range-start": isRangeStart,
            "is-range-end": isRangeEnd,
            "is-range-selection": isSelected && "highlightedRange" in state,
            "is-selection-start": isSelectionStart,
            "is-selection-end": isSelectionEnd,
            "is-hovered": isHovered,
            "is-pressed": isPressed && !state.isReadOnly,
            "is-invalid": isInvalid
        })
    }, /*#__PURE__*/ (0, $40VnT$react).createElement("span", {
        className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-dateText")
    }, /*#__PURE__*/ (0, $40VnT$react).createElement("span", null, formattedDate))));
}








function $faa2f3867773cfe5$export$26e2752316b9a375(props) {
    let { state: state, startDate: startDate } = props;
    let { gridProps: gridProps, headerProps: headerProps, weekDays: weekDays } = (0, $40VnT$useCalendarGrid)({
        ...props,
        endDate: (0, $40VnT$endOfMonth)(startDate)
    }, state);
    let { locale: locale } = (0, $40VnT$useLocale)();
    let weeksInMonth = (0, $40VnT$getWeeksInMonth)(startDate, locale);
    return /*#__PURE__*/ (0, $40VnT$react).createElement("table", {
        ...gridProps,
        className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-body", "spectrum-Calendar-table")
    }, /*#__PURE__*/ (0, $40VnT$react).createElement("thead", headerProps, /*#__PURE__*/ (0, $40VnT$react).createElement("tr", null, weekDays.map((day, index)=>/*#__PURE__*/ (0, $40VnT$react).createElement("th", {
            key: index,
            className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-tableCell")
        }, /*#__PURE__*/ (0, $40VnT$react).createElement("span", {
            className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-dayOfWeek")
        }, day))))), /*#__PURE__*/ (0, $40VnT$react).createElement("tbody", null, [
        ...new Array(weeksInMonth).keys()
    ].map((weekIndex)=>/*#__PURE__*/ (0, $40VnT$react).createElement("tr", {
            key: weekIndex
        }, state.getDatesInWeek(weekIndex, startDate).map((date, i)=>date ? /*#__PURE__*/ (0, $40VnT$react).createElement((0, $453c556b9066da11$export$5d847498420df57b), {
                key: i,
                state: state,
                date: date,
                currentMonth: startDate
            }) : /*#__PURE__*/ (0, $40VnT$react).createElement("td", {
                key: i
            }))))));
}






var $3bf3e8635a799a6e$exports = {};


































$3bf3e8635a799a6e$exports = {
    "ar-AE": $c1fdee2284f63122$exports,
    "bg-BG": $81326fc5b8464f3e$exports,
    "cs-CZ": $61bec992b8f61b70$exports,
    "da-DK": $92192aa23ec84b2d$exports,
    "de-DE": $4db8629ea44949b0$exports,
    "el-GR": $d1795c2b69d00f6c$exports,
    "en-US": $16d2015735d51a41$exports,
    "es-ES": $96cd1e101026681b$exports,
    "et-EE": $1133d3628ea10323$exports,
    "fi-FI": $53163229660d53e4$exports,
    "fr-FR": $d0808f7b535fb9b6$exports,
    "he-IL": $658f594fbca84b9b$exports,
    "hr-HR": $0b62e8a6414bc20c$exports,
    "hu-HU": $132d1b97de231314$exports,
    "it-IT": $5653a55498966c6c$exports,
    "ja-JP": $243f99057b9b0af0$exports,
    "ko-KR": $9dbe802a4c1b47ed$exports,
    "lt-LT": $ed6bec4d46a5be1b$exports,
    "lv-LV": $e203254b4140c831$exports,
    "nb-NO": $87004dc1feacb708$exports,
    "nl-NL": $fd392c0c0b12ff84$exports,
    "pl-PL": $02f96c467435edbf$exports,
    "pt-BR": $a516ff2265dc1cde$exports,
    "pt-PT": $2a8fe7dc6b71b8d6$exports,
    "ro-RO": $459c636d0d282e8f$exports,
    "ru-RU": $d49b96bc4e237385$exports,
    "sk-SK": $14f44f430d85943b$exports,
    "sl-SI": $ced45866328d3850$exports,
    "sr-SP": $46417484d64689f8$exports,
    "sv-SE": $9d8ccb39096f4575$exports,
    "tr-TR": $8e9c1a10ed1cc18a$exports,
    "uk-UA": $84c3bf1d3eaf1f59$exports,
    "zh-CN": $0212afd59952ac06$exports,
    "zh-TW": $87077630a4e30349$exports
};






function $62cd1e80f0dffb66$export$bfd52a43017368fe(props) {
    let { state: state, calendarProps: calendarProps, nextButtonProps: nextButtonProps, prevButtonProps: prevButtonProps, errorMessageProps: errorMessageProps, calendarRef: ref, visibleMonths: visibleMonths = 1 } = props;
    let { styleProps: styleProps } = (0, $40VnT$useStyleProps)(props);
    let stringFormatter = (0, $40VnT$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($3bf3e8635a799a6e$exports))), "@react-spectrum/calendar");
    let { direction: direction } = (0, $40VnT$useLocale)();
    let currentMonth = state.visibleRange.start;
    let monthDateFormatter = (0, $40VnT$useDateFormatter)({
        month: "long",
        year: "numeric",
        era: currentMonth.calendar.identifier === "gregory" && currentMonth.era === "BC" ? "short" : undefined,
        calendar: currentMonth.calendar.identifier,
        timeZone: state.timeZone
    });
    let titles = [];
    let calendars = [];
    for(let i = 0; i < visibleMonths; i++){
        let d = currentMonth.add({
            months: i
        });
        titles.push(/*#__PURE__*/ (0, $40VnT$react).createElement("div", {
            key: i,
            className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-monthHeader")
        }, i === 0 && /*#__PURE__*/ (0, $40VnT$react).createElement((0, $40VnT$ActionButton), {
            ...prevButtonProps,
            UNSAFE_className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-prevMonth"),
            isQuiet: true
        }, direction === "rtl" ? /*#__PURE__*/ (0, $40VnT$react).createElement((0, $40VnT$spectrumiconsuiChevronRightLarge), null) : /*#__PURE__*/ (0, $40VnT$react).createElement((0, $40VnT$spectrumiconsuiChevronLeftLarge), null)), /*#__PURE__*/ (0, $40VnT$react).createElement("h2", {
            // We have a visually hidden heading describing the entire visible range,
            // and the calendar itself describes the individual month
            // so we don't need to repeat that here for screen reader users.
            "aria-hidden": true,
            className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-title")
        }, monthDateFormatter.format(d.toDate(state.timeZone))), i === visibleMonths - 1 && /*#__PURE__*/ (0, $40VnT$react).createElement((0, $40VnT$ActionButton), {
            ...nextButtonProps,
            UNSAFE_className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-nextMonth"),
            isQuiet: true
        }, direction === "rtl" ? /*#__PURE__*/ (0, $40VnT$react).createElement((0, $40VnT$spectrumiconsuiChevronLeftLarge), null) : /*#__PURE__*/ (0, $40VnT$react).createElement((0, $40VnT$spectrumiconsuiChevronRightLarge), null))));
        calendars.push(/*#__PURE__*/ (0, $40VnT$react).createElement((0, $faa2f3867773cfe5$export$26e2752316b9a375), {
            ...props,
            key: i,
            state: state,
            startDate: d
        }));
    }
    return /*#__PURE__*/ (0, $40VnT$react).createElement("div", {
        ...styleProps,
        ...calendarProps,
        ref: ref,
        className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar", styleProps.className)
    }, /*#__PURE__*/ (0, $40VnT$react).createElement((0, $40VnT$VisuallyHidden), null, /*#__PURE__*/ (0, $40VnT$react).createElement("h2", null, calendarProps["aria-label"])), /*#__PURE__*/ (0, $40VnT$react).createElement("div", {
        className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-header")
    }, titles), /*#__PURE__*/ (0, $40VnT$react).createElement("div", {
        className: (0, $40VnT$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($52c51313300b3b3e$exports))), "spectrum-Calendar-months")
    }, calendars), /*#__PURE__*/ (0, $40VnT$react).createElement((0, $40VnT$VisuallyHidden), null, /*#__PURE__*/ (0, $40VnT$react).createElement("button", {
        "aria-label": nextButtonProps["aria-label"],
        disabled: nextButtonProps.isDisabled,
        onClick: ()=>state.focusNextPage(),
        tabIndex: -1
    })), state.isValueInvalid && /*#__PURE__*/ (0, $40VnT$react).createElement((0, $40VnT$HelpText), {
        showErrorIcon: true,
        errorMessage: props.errorMessage || stringFormatter.format("invalidSelection", {
            selectedCount: "highlightedRange" in state ? 2 : 1
        }),
        errorMessageProps: errorMessageProps,
        isInvalid: true,
        // Intentionally a global class name so it can be targeted in DatePicker CSS...
        UNSAFE_className: "spectrum-Calendar-helpText"
    }));
}









function $d2b8d4577dd88671$var$Calendar(props, ref) {
    props = (0, $40VnT$useProviderProps)(props);
    let { visibleMonths: visibleMonths = 1 } = props;
    visibleMonths = Math.max(visibleMonths, 1);
    let visibleDuration = (0, $40VnT$useMemo)(()=>({
            months: visibleMonths
        }), [
        visibleMonths
    ]);
    let { locale: locale } = (0, $40VnT$useLocale)();
    let state = (0, $40VnT$useCalendarState)({
        ...props,
        locale: locale,
        visibleDuration: visibleDuration,
        createCalendar: $40VnT$createCalendar
    });
    let domRef = (0, $40VnT$useRef)();
    (0, $40VnT$useImperativeHandle)(ref, ()=>({
            ...(0, $40VnT$createDOMRef)(domRef),
            focus () {
                state.setFocused(true);
            }
        }));
    let { calendarProps: calendarProps, prevButtonProps: prevButtonProps, nextButtonProps: nextButtonProps, errorMessageProps: errorMessageProps } = (0, $40VnT$useCalendar)(props, state);
    return /*#__PURE__*/ (0, $40VnT$react).createElement((0, $62cd1e80f0dffb66$export$bfd52a43017368fe), {
        ...props,
        visibleMonths: visibleMonths,
        state: state,
        calendarRef: domRef,
        calendarProps: calendarProps,
        prevButtonProps: prevButtonProps,
        nextButtonProps: nextButtonProps,
        errorMessageProps: errorMessageProps
    });
}
/**
 * Calendars display a grid of days in one or more months and allow users to select a single date.
 */ const $d2b8d4577dd88671$export$e1aef45b828286de = /*#__PURE__*/ (0, $40VnT$react).forwardRef($d2b8d4577dd88671$var$Calendar);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 







function $8b1e8eddbf3b15de$var$RangeCalendar(props, ref) {
    props = (0, $40VnT$useProviderProps)(props);
    let { visibleMonths: visibleMonths = 1 } = props;
    visibleMonths = Math.max(visibleMonths, 1);
    let visibleDuration = (0, $40VnT$useMemo)(()=>({
            months: visibleMonths
        }), [
        visibleMonths
    ]);
    let { locale: locale } = (0, $40VnT$useLocale)();
    let state = (0, $40VnT$useRangeCalendarState)({
        ...props,
        locale: locale,
        visibleDuration: visibleDuration,
        createCalendar: $40VnT$createCalendar
    });
    let domRef = (0, $40VnT$useRef)();
    (0, $40VnT$useImperativeHandle)(ref, ()=>({
            ...(0, $40VnT$createDOMRef)(domRef),
            focus () {
                state.setFocused(true);
            }
        }));
    let { calendarProps: calendarProps, prevButtonProps: prevButtonProps, nextButtonProps: nextButtonProps, errorMessageProps: errorMessageProps } = (0, $40VnT$useRangeCalendar)(props, state, domRef);
    return /*#__PURE__*/ (0, $40VnT$react).createElement((0, $62cd1e80f0dffb66$export$bfd52a43017368fe), {
        ...props,
        visibleMonths: visibleMonths,
        state: state,
        calendarRef: domRef,
        calendarProps: calendarProps,
        prevButtonProps: prevButtonProps,
        nextButtonProps: nextButtonProps,
        errorMessageProps: errorMessageProps
    });
}
/**
 * RangeCalendars display a grid of days in one or more months and allow users to select a contiguous range of dates.
 */ const $8b1e8eddbf3b15de$export$a4f5c8b89d277a8d = /*#__PURE__*/ (0, $40VnT$react).forwardRef($8b1e8eddbf3b15de$var$RangeCalendar);




export {$d2b8d4577dd88671$export$e1aef45b828286de as Calendar, $8b1e8eddbf3b15de$export$a4f5c8b89d277a8d as RangeCalendar};
//# sourceMappingURL=module.js.map
